import Vue from 'vue'
import Book from 'vue-book-component'
import App from './App.vue'

Vue.use(Book)

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js